module.exports = __webpack_public_path__ + "img/logo.7b56b992.png";